import { PlexUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { SvgIconComponent } from '@material-ui/icons';
import React from 'react';

import { usePlexesMap, useSelectedPlexIds } from '../../../models/filters/useSelectedPlexIds';
import { ButtonColor, PlexButton } from '../../shared/primitives/PlexButton';

export const NewPlexLevelEntityButton = React.memo(function NewQuestionButton({
  className,
  canPerformAction,
  label,
  onClick,
  MuiIconRight,
}: {
  className?: string;
  canPerformAction: (state: PlexUserRelationState) => boolean;
  label: string;
  onClick: (args: { plexId: string }) => void;
  MuiIconRight: SvgIconComponent;
}): React.ReactElement {
  const plexIds = useSelectedPlexIds();
  const plexesMap = usePlexesMap();
  const handleClickOpen = (): void => {
    onClick({ plexId: plexIds[0] });
  };

  const disabledReason = ((): string | undefined => {
    if (plexIds.length === 0) {
      // we can get this case when there is no plex created
      return 'You must have at least 1 plex selected';
    }

    if (plexIds.length > 1) {
      return 'You have selected more than 1 plex';
    }

    const userRelation = plexesMap[plexIds[0]]?.currentUserRelation.state;
    if (!userRelation || !canPerformAction(userRelation)) {
      return "You don't have permission to perform this action.";
    }

    return undefined;
  })();

  return (
    <PlexButton
      disabled={disabledReason != null}
      className={className}
      onClick={handleClickOpen}
      label={label}
      MuiIconRight={MuiIconRight}
      color={ButtonColor.Primary}
      tooltip={disabledReason}
    />
  );
});
